import "./Project.scss";

import CardListContainer from "../../components/CardListContainer/CardListContainer";

export default function Project() {
  return <CardListContainer />;
}
